import PropTypes from 'prop-types';

function Body({ children }) {
  return <main className="px-4 pb-4 md:px-6 md:pb-6">{children}</main>;
}

Body.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Body;
